export default __webpack_public_path__ + "static/media/IND.b4edf60f.svg";